import PropTypes from 'prop-types';
import React from 'react';
import PrimaryActionButton from './primary-action-button';
import constants from 'contest/data/constants';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';

class MainDesignAction extends React.Component {
    isCreatorActiveUser() {
        return (
            this.props.activeUser &&
            this.props.activeUser.userId === this.props.design.creator.userId
        );
    }

    validPrimaryActions() {
        const design = this.props.design;

        return {
            [constants.VIEW_CUSTOMER_HANDOVER]:
                design.isWinner && design.permission.canViewHandover && !this.isCreatorActiveUser(),
            [constants.VIEW_DESIGNER_HANDOVER]:
                design.isWinner && design.permission.canViewHandover && this.isCreatorActiveUser(),
        };
    }

    hasValidPrimaryActions() {
        const validActions = this.validPrimaryActions();

        return Object.keys(validActions).some(action => {
            return validActions[action];
        });
    }

    render() {
        if (!this.hasValidPrimaryActions()) {
            return null;
        }

        return (
            <div className="design-actions-panel__action">
                <ButtonGroup variations={['fluid', 'joined']}>
                    <ButtonGroupItem variations={['grow']}>
                        <PrimaryActionButton
                            design={this.props.design}
                            activeUser={this.props.activeUser}
                            actions={this.validPrimaryActions()}
                        />
                    </ButtonGroupItem>
                </ButtonGroup>
            </div>
        );
    }
}

MainDesignAction.propTypes = {
    design: PropTypes.object.isRequired,
    activeUser: PropTypes.object,
};

export default MainDesignAction;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/main-design-action.jsx